import { render, staticRenderFns } from "./MmodelsIndex.vue?vue&type=template&id=76ac22bb"
import script from "./MmodelsIndex.vue?vue&type=script&lang=js"
export * from "./MmodelsIndex.vue?vue&type=script&lang=js"
import style0 from "./MmodelsIndex.vue?vue&type=style&index=0&id=76ac22bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports